import React, {Component} from 'react';
import Table from '../../../components/common/Table';
import {PopoverInteractionKind, Position, Popover} from '@blueprintjs/core/lib/esm/index';

class SharedFeedsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: "none",
            clicked_id: "",
            clicked_index: ""
        };
    }

    toggleMemberData = (e) => {
        this.setState({
            clicked_id: e.target.id,
            clicked_index: e.target.name || e.target.title
        });
        if (this.state.display === "none") {
            this.setState({display: "block"});
        } else {
            this.setState({display: "none"})
        }
    };

    addDefaultSrc = (ev) => {
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }

    render() {
        const {feeds, onClick, onSort, sortColumn} = this.props;
        const {clicked_id, clicked_index} = this.state;
        const columns = [
            {
                path: "name", label: "Workspace Name",
                content: item => <div>{item.name}</div>

            },
            {
                path: "current_subscription",
                   label: "Subscription",
                content: item => {
                    switch (item.current_subscription) {
                        case 'martech_ltd_3':
                            return 'Martech 3'

                        case 'martech_ltd_2':
                            return 'Martech 2'

                        case 'martech_ltd_1':
                            return 'Martech 1'

                        default:
                            return item.current_subscription;
                    }
                }
                //item.current_subscription === 'martech_ltd_3' ? 'Martech 3' : ''

            },

            {
                path: "shared_by", label: "Shared by",
                content: item => <div
                    //id="shared_by"
                >


                    {item.shared_by.first_name + ' ' + item.shared_by.last_name}
                </div>
            },
            {
                path: "admins", label: "Admins",
                content: item =>

                    <div className='flex-row'>
                        <div className='table-admin'>
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}
                               
                                position={Position.LEFT_TOP}
                                style={{padding: 0}}
                                minimal={true}
                            >
                                <img name={item.id} title={item.shared_by.name}
                                     src={item.shared_by.profile_photo ? item.shared_by.profile_photo : '/img/default-user.jpg'}
                                     alt="user" onError={this.addDefaultSrc}/>
                                <div className="team-user-panel padding-10"
                                     style={{display: 'block'}}>
                                    <div className="display-flex" style={{display: 'flex', alignItems: 'center'}}>

                                        <img
                                            src={item.shared_by.profile_photo ? item.shared_by.profile_photo : '/img/default-user.jpg'}
                                            alt="user" onError={this.addDefaultSrc}
                                            style={{
                                                width: 50, height: 50, borderRadius: '100%',
                                                objectFit: "cover"
                                            }}/>
                                        <div className="col-xs-9">
                                            <div className="team-user-name">{item.shared_by.name}</div>
                                            <div className="team-user-email">{item.shared_by.email}</div>
                                        </div>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                        {item.admins && item.admins.map((admin, index) =>
                            <div className='table-admin' id={admin.id} key={index}>
                                <Popover
                                    interactionKind={PopoverInteractionKind.CLICK}
                                   
                                    position={Position.LEFT_TOP}
                                    style={{padding: 0}}
                                    minimal={true}
                                >
                                    <img id={admin.id} name={item.id} title={admin.name}
                                         src={admin.profile_photo ? admin.profile_photo : '/img/default-user.jpg'}
                                         alt="user" onError={this.addDefaultSrc} style={{marginRight: 0}}/>
                                    <div className="team-user-panel padding-10"
                                         style={{display: 'block'}}>
                                        <div className="display-flex" style={{display: 'flex', alignItems: 'center'}}>

                                            <img
                                                src={admin.profile_photo ? admin.profile_photo : '/img/default-user.jpg'}
                                                alt="user" onError={this.addDefaultSrc}
                                                style={{width: 50, height: 50, borderRadius: '100%'}}/>
                                            <div className="col-xs-9">
                                                <div className="team-user-name">{admin.name}</div>
                                                <div className="team-user-email">{admin.email}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )}

                        {item.pending_admins && item.pending_admins.map((pending_admin, index) =>
                            <div id={pending_admin.id} key={index}>
                                <Popover
                                    interactionKind={PopoverInteractionKind.CLICK}
                                   
                                    position={Position.LEFT_TOP}
                                    style={{padding: 0}}
                                    minimal={true}
                                >
                                    <span className="pending-reg fas fa-user"
                                          id={pending_admin.id}
                                          name={pending_admin.name || ""}
                                          title={item.id}
                                          style={{
                                              padding: "6px 8px",
                                              cursor: "pointer",
                                              backgroundColor: "white",
                                              border: "1px solid #344A5E",
                                              color: "#344A5E",
                                              borderRadius: "100%",
                                              width: "31px",
                                              height: "31px",
                                              marginRight: 0
                                          }}>
                                    </span>
                                    <div className="team-user-panel padding-10"
                                         style={{display: 'block'}}>
                                        <div className="display-flex" style={{display: 'flex', alignItems: 'center'}}>

                                            <span className="pending-reg fas fa-user"
                                                  style={{
                                                      padding: "6px 8px",
                                                      cursor: "auto",
                                                      backgroundColor: "white",
                                                      border: "1px solid #344A5E",
                                                      color: "#344A5E",
                                                      borderRadius: "100%",
                                                      width: "50px",
                                                      height: "50px",
                                                      fontSize: "37px",
                                                      textAlign: "center"
                                                  }}>
                                            </span>
                                            <div className="col-xs-9">
                                                <div
                                                    className="team-user-name">{pending_admin.name || "Registration pending"}</div>
                                                <div className="team-user-email">{pending_admin.email}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )}
                    </div>

            }


        ];
        return (
            <div className="table-scroll m-lg-b">
                <Table
                    data={feeds}
                    columns={columns}
                    sortColumn={sortColumn}
                    onSort={onSort}
                    onClick={onClick}/>
            </div>
        );
    }
}

export default SharedFeedsTable